<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="para"><span class="smallcaps">THERE’S SOMETHING ABOUT ST. TROPEZ</span>. Copyright © 2009 by Ardnavarna, Inc. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="para">Design by Sarah Gubkin</p>
<p class="para"> </p>
<p class="para"><span class="smallcaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="para"> </p>
<p class="para">Adler, Elizabeth (Elizabeth A.)</p>
<p class="indent-para">There’s something about St. Tropez / Elizabeth Adler. — 1st ed.</p>
<p class="indent-para">        p. cm.</p>
<p class="indent-para">ISBN 13: 978-0-312-38514-9</p>
<p class="indent-para">ISBN 10: 0-312-38514-5</p>
<p class="indent-para">1. Private investigators—Fiction. 2. Television actors and actresses—Fiction. 3. Saint-Tropez (France)—Fiction. 4. Vacation rentals—Fiction. 5. Villas—Fiction. 6. Strangers—Fiction. 7. Murder—Investigation—Fiction. I. Title. II. Title: There’s something about Saint-Tropez.</p>
<p class="indent-para">PR6051.D56T48 2009</p>
<p class="indent-para">823'.914—dc22</p>
<p class="right-para">2009007676</p>
<p class="para">First Edition: July 2009</p>
<p class="para"> </p>
<p class="para">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0c5ec8d8